import { connect } from 'react-redux';
import * as R from 'ramda';
import { createSelector } from 'reselect';
import { withProps, compose } from 'recompose';
import Map from 'components/general/Map/Map';
import { selectors } from './../ducks/article.duck';
import getUserAbility from 'state/selectors/getUserAbility';

const getMarker = createSelector(
  selectors.data,
  alert => ({
    [alert.id]: {
      id: alert.id,
      title: alert.title,
      coordinates: alert.point,
      data: alert,
    },
  }),
);

const getCanZoomAndPan = createSelector(
  getUserAbility,
  ability => ability.can('use', 'map'),
);

// alert.point is [lat, lng]; mapbox center expects [lng, lat].
const getCenter = createSelector(
  selectors.data,
  alert => alert.point && R.reverse(alert.point),
);

const mapStateToProps = R.applySpec({
  markers: getMarker,
  selectedMarker: R.pipe(
    selectors.data,
    R.prop('id'),
  ),
  scrollZoom: getCanZoomAndPan,
  dragPan: getCanZoomAndPan,
  loading: selectors.loading,
  gis: R.pipe(getCenter, center => (center ? { center } : undefined)),
});

const AlertsIndexMap = compose(
  withProps({ setFocus: true }),
  connect(mapStateToProps),
)(Map);

export default AlertsIndexMap;
